import { render, staticRenderFns } from "./CreateForm2.vue?vue&type=template&id=220c2b63&scoped=true"
import script from "./CreateForm2.vue?vue&type=script&lang=js"
export * from "./CreateForm2.vue?vue&type=script&lang=js"
import style0 from "./CreateForm2.vue?vue&type=style&index=0&id=220c2b63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220c2b63",
  null
  
)

export default component.exports